import React, { useContext } from "react"
import { checkGameStarted } from "../../../Base/Utilities/Game";
import { lightOrDark } from "../../../Base/Utilities/LightOrDark";
import {
  getActiveSuspensionForPerson,
  getCardsForPerson,
} from "../../../Base/Utilities/Suspension";
import { FixtureDetailsContext } from "../../../../Config/FixtureDetails";

const HandballPlayer = (props) => {
  const { player, teamColor, entity, currentState, eventStore, onPlayerClickHandler } = props;
  const { fixtureProfile } = useContext(FixtureDetailsContext);

  const isGameStarted = checkGameStarted(props);

  const onPlayerClick = (player) => {
    if (!isGameStarted) {
      return;
    }

    onPlayerClickHandler(player);
  };

  const activeCardEvent = getCardsForPerson({
    entity,
    personId: player.personId,
    events: eventStore,
    fixtureProfile,
  });

  const activeSuspensionEvent = getActiveSuspensionForPerson({
    entity,
    personId: player.personId,
    events: eventStore,
    displayTime: currentState?.clock?.displayTime,
    periodId: currentState?.period?.periodId,
    fixtureProfile,
  });

  const renderTileFooter = () => {
    if (activeSuspensionEvent) {
      const { remainingTime } = activeSuspensionEvent;
      const minutes = Math.floor(remainingTime / 60);
      const seconds = remainingTime - minutes * 60;
      const timeStr = `${minutes}:${String(seconds).padStart(2, "0")}`;
      return (
        <div className="player-tile__card">
          <div className="fas fa-ban" />
          <span className="player-tile__card-text">{timeStr}</span>
        </div>
      );
    }

    if (activeCardEvent.eventType === "yellowCard") {
      return (
        <div className="player-tile__card">
          <div className="player-tile__card-box player-tile__card-box--yellow" />
        </div>
      );
    }

    if (activeCardEvent.eventType === "redCard") {
      return (
        <div className="player-tile__card">
          <div className="player-tile__card-box player-tile__card-box--red" />
          <span className="player-tile__card-text">DQ</span>
        </div>
      );
    }

    if (activeCardEvent.eventType === "blueCard") {
      return (
        <div className="player-tile__card">
          <div className="player-tile__card-box player-tile__card-box--blue" />
          <span className="player-tile__card-text">DQ</span>
        </div>
      );
    }

    return null;
  };

  const isSuspended =
    activeSuspensionEvent ||
    (activeCardEvent && activeCardEvent.eventType !== "yellowCard");

  const shouldRenderTileFooter = activeCardEvent || activeSuspensionEvent;

  return (
    <div
      className={`player-tile ${player.active ? "active" : ""} ${lightOrDark(
        teamColor
      )}${!isGameStarted ? " player-tile--disabled" : ""}${
        isSuspended ? " player-tile--suspended" : ""
      }`}
      style={{
        backgroundColor: player.active ? teamColor : "#3B444C",
      }}
      onClick={() => onPlayerClick(player)}
    >
      <>
        {player.bib}
        {player.captain && " (C)"}
      </>
      {shouldRenderTileFooter && renderTileFooter()}
    </div>
  );
};

export default HandballPlayer;
